import useTranslation from "@babackapp/translations/use-translation";
import { StarIcon } from "lucide-react";

export function PremiumFeature() {
  const t = useTranslation();
  return (
    <div className="border border-amber-400 text-amber-500 bg-amber-50 px-2 py-1 rounded flex items-center h-fit space-x-2">
      <StarIcon className="h-4 w-4 " />
      <div className="">{t("settings.entrepriseFeature")}</div>
    </div>
  );
}
